import { warehouseFlaggedProblemReasonIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const ItemReviewFailReason_ = z.object({
  id: warehouseFlaggedProblemReasonIdFormat.schema,
  reason: z.string(),
});
export const ItemReviewFailReason: z.ZodType<ItemReviewFailReason> =
  ItemReviewFailReason_;
export interface ItemReviewFailReason extends z.infer<
  typeof ItemReviewFailReason_
> {}

export const listItemReviewFailReasons = {
  name: "listItemReviewFailReasons" as const,
  input: z.object({}),
  output: z.object({ reasons: z.array(ItemReviewFailReason_) }),
};
